/**
 * Shared Emotion CSS helpers.
 *
 * gradientText — gradient-clipped titles that fall back to a solid color
 * under html[data-platform='tizen'] (Samsung TV / low-gfx). The clip:text
 * mask + transparent fill paints garbage pixels on old Tizen GPUs; leaving
 * the gradient as a background box after killing the clip is equally bad,
 * so the Tizen path clears the background entirely.
 */
import { css } from '@emotion/react';

/**
 * @param {string} from - Start color (or "color 0%")
 * @param {string} to - End color (or "color 100%")
 * @param {string} fallback - Solid color used on Tizen / low-gfx devices
 */
export function gradientText(from, to, fallback) {
  return css`
    background: linear-gradient(135deg, ${from}, ${to});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;

    html[data-platform='tizen'] & {
      background: none;
      color: ${fallback};
      -webkit-text-fill-color: currentColor;
    }
  `;
}

export default { gradientText };
